import React from 'react';

import {AttachOverlay} from 'app/general/overlays';
import {
  PrintableContentTypes,
  PrintDocumentPopover,
} from 'app/procedures/components/PrintDocumentPopover';
import {gt} from 'app/utils/i18n';

type Props = {
  canEdit: boolean;
  contentType: PrintableContentTypes;
  objectId: number;
  addToPayload?:
    | {
        taskinstance: string;
      }
    | {signoff_id: number};
};

export function PrintTaskButton({
  objectId,
  contentType,
  canEdit,
  addToPayload,
}: Props): JSX.Element | null {
  if (canEdit === false) {
    return null;
  }

  return (
    <AttachOverlay
      trigger="click legacy"
      overlay={({overlayProps}) => (
        <PrintDocumentPopover
          objectId={objectId}
          contentType={contentType}
          addToPayload={addToPayload}
          overlayProps={{...overlayProps, placement: 'bottom'}}
        />
      )}
    >
      {(handlers) => (
        <div className="btn-group">
          <button
            {...handlers}
            type="button"
            className="btn d-print-none btn-link"
          >
            {gt('Export')}
          </button>
        </div>
      )}
    </AttachOverlay>
  );
}
